import * as actions from "./actions.js";
export var errorToAction = function errorToAction(error) {
  if (error.displayMessage) {
    return actions.receivedGlobalError(error);
  }
};
export var handleError = function handleError(error) {
  var action = errorToAction(error);
  if (action) {
    return action;
  } else {
    throw error;
  }
};